<script lang="ts">
	import type { FormEventHandler } from 'svelte/elements';

	let {
		class: className = '',
		placeholder = 'Search',
		value = $bindable(''),
		oninput
	}: {
		class?: string;
		placeholder?: string;
		value?: string;
		oninput: (value: string) => void;
	} = $props();

	const handleInput: FormEventHandler<HTMLInputElement> = (event) => {
		value = event.currentTarget.value;
		oninput(value);
	};
</script>

<input
	class="rounded-3xl border-2 border-gray-300 bg-gray-100 px-4 py-2 text-sm text-gray-700 placeholder-gray-500 transition-colors duration-200 hover:bg-gray-50 focus:border-blue-500 focus:bg-gray-50 focus:ring focus:ring-blue-200 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:placeholder-gray-400 dark:hover:bg-gray-700 dark:focus:bg-gray-700 dark:focus:text-gray-400 {className}"
	type="text"
	{placeholder}
	{value}
	oninput={handleInput}
/>
